// extracted by mini-css-extract-plugin
export var card = "_lm-0";
export var content = "_lm-2";
export var details = "_lm-3";
export var icon = "_lm-1";
export var iconBlue = "_lm-5";
export var iconBrand = "_lm-4";
export var iconGrayBlue = "_lm-6";
export var iconGreen = "_lm-7";
export var iconIndigo = "_lm-8";
export var iconOrange = "_lm-9";
export var iconPurple = "_lm-a";
export var iconRed = "_lm-b";
export var iconWarning = "_lm-c";